(() => {
  if (window.yvyGuidesBound) return;
  window.yvyGuidesBound = true;
  // Lumia's popup delegates clicks on its content. Handle this disclosure
  // before that delegate, and keep its scroll viewport sized to the new rows.
  document.addEventListener('click', event => {
    const summary = event.target.closest('.yvy-guides-nav--mobile summary');
    if (!summary) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const menu = summary.parentElement;
    menu.open = !menu.open;
    requestAnimationFrame(() => {
      const wrapper = summary.closest('.nav-wrapper');
      const list = wrapper && wrapper.querySelector('ul.nav');
      if (list) wrapper.style.height = `${list.scrollHeight}px`;
    });
  }, true);
  // Keep article contents independent of Lumia's generic hash-link handler.
  document.addEventListener('click', event => {
    const link = event.target.closest('.yvy-toc a[href^="#"]');
    if (!link) return;
    const heading = document.getElementById(decodeURIComponent(link.hash.slice(1)));
    if (!heading) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    history.replaceState(null, '', link.href);
    heading.scrollIntoView({ block: 'start', behavior: 'instant' });
  }, true);
  const positionMenu = menu => {
    const nav = menu.closest('.yvy-guides-nav');
    if (!menu.open || !nav || nav.classList.contains('yvy-guides-nav--mobile')) return;
    const panel = menu.querySelector('.yvy-guides-panel');
    if (!panel || !panel.getClientRects().length) return;
    // Start below Guides; shift only as much as the viewport edge requires.
    panel.style.removeProperty('--yvy-menu-offset');
    const rect = panel.getBoundingClientRect();
    const viewport = document.documentElement.clientWidth;
    const left = Math.max(20, Math.min(rect.left, viewport - rect.width - 20));
    panel.style.setProperty('--yvy-menu-offset', `${left - rect.left}px`);
    panel.style.setProperty('--yvy-menu-height', `${Math.max(100, window.innerHeight - rect.top - 20)}px`);
  };
  const positionOpenMenus = () => document.querySelectorAll('.yvy-guides-nav details[open]').forEach(positionMenu);
  document.addEventListener('toggle', event => {
    if (event.target.matches('.yvy-guides-nav details')) positionMenu(event.target);
  }, true);
  window.addEventListener('resize', positionOpenMenus);
  document.addEventListener('click', event => {
    document.querySelectorAll('.yvy-guides-nav details[open]').forEach(menu => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.yvy-guides-nav details[open]').forEach(menu => {
      menu.open = false;
      menu.querySelector('summary').focus();
    });
  });
  const wrapTables = () => document.querySelectorAll('.yvy-prose table').forEach(table => {
    if (table.parentElement.classList.contains('yvy-table-scroll')) return;
    const wrapper = document.createElement('div');
    wrapper.className = 'yvy-table-scroll';
    wrapper.tabIndex = 0;
    wrapper.setAttribute('role', 'region');
    wrapper.setAttribute('aria-label', 'Scrollable article table');
    table.before(wrapper); wrapper.append(table);
  });
  // Reading aids are generated from the existing body, never extra author fields.
  const buildArticleContents = () => document.querySelectorAll('.yvy-article').forEach(article => {
    const toc = article.querySelector('.yvy-toc');
    if (!toc || toc.dataset.bound) return;
    toc.dataset.bound = 'true';
    const headings = Array.from(article.querySelectorAll('.yvy-prose h2')).filter(heading => heading.textContent.trim());
    if (headings.length < 2) return;
    const list = toc.querySelector('ol');
    const links = new Map();
    headings.forEach((heading, index) => {
      if (!heading.id || document.querySelectorAll(`#${CSS.escape(heading.id)}`).length > 1) {
        let id = `yvy-section-${index + 1}`;
        while (document.getElementById(id)) id += '-section';
        heading.id = id;
      }
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${encodeURIComponent(heading.id)}`;
      link.textContent = heading.textContent.trim();
      item.append(link); list.append(item); links.set(heading, link);
    });
    toc.hidden = false;
    toc.querySelector('details').open = window.matchMedia('(min-width: 901px)').matches;
    let framePending = false;
    const updateActiveHeading = () => {
      framePending = false;
      let current = headings[0];
      for (const heading of headings) {
        if (heading.getBoundingClientRect().top > 150) break;
        current = heading;
      }
      links.forEach(link => link.removeAttribute('aria-current'));
      links.get(current).setAttribute('aria-current', 'location');
    };
    window.addEventListener('scroll', () => {
      if (framePending) return;
      framePending = true;
      requestAnimationFrame(updateActiveHeading);
    }, { passive: true });
    updateActiveHeading();
  });
  const initialise = () => { wrapTables(); buildArticleContents(); positionOpenMenus(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise);
  else initialise();
  if (document.fonts) document.fonts.ready.then(positionOpenMenus);
  document.addEventListener('shopify:section:load', initialise);
})();
